import React from 'react';
import { Users, Star, BookOpen, Gift } from 'lucide-react';
export function StatsBar() {
  const stats = [{
    icon: <Users className="text-brand" data-id="element-280" />,
    value: '+1.200',
    label: 'usuarios confían'
  }, {
    icon: <Star className="text-accent" data-id="element-281" />,
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    icon: <BookOpen className="text-blue-400" data-id="element-282" />,
    value: '3',
    label: 'eBooks completos'
  }, {
    icon: <Gift className="text-purple-400" data-id="element-283" />,
    value: 'Bonos',
    label: 'incluidos'
  }];
  return <div className="w-full border-y border-border bg-surface/50 backdrop-blur-sm py-6" data-id="element-284">
      <div className="max-w-6xl mx-auto px-4" data-id="element-285">
        <div className="flex overflow-x-auto hide-scrollbar md:grid md:grid-cols-4 gap-8 md:gap-4 snap-x" data-id="element-286">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center min-w-[150px] snap-center text-center" data-id="element-287">
              <div className="mb-2" data-id="element-288">{stat.icon}</div>
              <div className="text-2xl font-heading font-bold text-white" data-id="element-289">
                {stat.value}
              </div>
              <div className="text-sm text-muted" data-id="element-290">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </div>;
}